import { createContext } from "react";

const CompanycolorContext = createContext();

export default CompanycolorContext;